export default __webpack_public_path__ + "7115ce7694c54fb175d4cd66f076ed8e.jpg";